<svelte:body on:click={outsideClick} />

<div bind:this={child} class={extraClass}>
  <slot></slot>
</div>

<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()
  export let excluded = []
  export let extraClass = ''
  let child

  function isInside (target) {
    while (target) {
      if (excluded.indexOf(target) >= 0 || target === child) {
        return true
      }
      target = target.parentNode
    }

    return false
  }

  function outsideClick (e) {
    if (!isInside(e.target)) {
      dispatch('outsideClick')
    }
  }
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>